namespace $.$$ {
	export class $shm_hitalama_map_widget_float_code_css extends $.$shm_hitalama_map_widget_float_code_css {
		
		@ $mol_mem
		attach() {
			if( !this.enabled() ) return null

			const code = this.$.$shm_hitalama_compat_fqn_css( this.widget().preprocessed() )
			const id = this.widget().link().toString()

			const style_el = this.$.$mol_style_attach( id, code )
			if( style_el ) Object.assign( style_el, {
				destructor() {
					style_el.remove()
				}
			} )
			
			return style_el
		}

		enabled( next?: boolean ): boolean {
			return this.widget().enabled(next) ?? true
		}
		
	}
}
